import Icon from "./Icon";

export default function EmptyState({ icon = "inbox", title, hint, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Icon name={icon} size={20} />
      </div>
      {title && <div className="empty-state-title">{title}</div>}
      {hint && <div className="text-sm">{hint}</div>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
